import { render, staticRenderFns } from "./NumberDashboardCard.vue?vue&type=template&id=38954746"
import script from "./NumberDashboardCard.vue?vue&type=script&lang=js"
export * from "./NumberDashboardCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports